import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Grid, Typography, Divider } from '@material-ui/core';
import DeleteCancel from '../../atoms/buttons/DeleteCancel';
import { useState, useEffect, Fragment } from 'react';


export default function RegenerateAlert({  onClose, onProceed }) {
    console.log("Onlocse----------", onClose)
    const dispatch = useDispatch();    
   
    const onRegenerate = () => {
        onProceed();
        onClose();
    }


    return (
        <Grid container direction={"row"} spacing={1} >

            <Grid item xs={12}>
                <Typography variant="h6" >Message</Typography>
            </Grid>
            <Grid item xs={12}>
                <Divider />
            </Grid>
            <Grid item xs={12}>
                <Typography> This action will regenerate transactions for the widgets in this view.  </Typography>
                        <Fragment>
                            <br />
                            <ol id="validationErrors">
                            <li key={1}>
                                <span style={{ fontWeight: 'bold' }}>Existing mapped transactions will be updated.</span>
                            </li>
                            <li key={1}>
                                <span style={{ fontWeight: 'bold' }}>Transactions that are no longer used will be permanently deleted.</span>
                            </li>
                            <li key={1}>
                                <span style={{ fontWeight: 'bold' }}>Any manual changes made to those transactions may be lost.</span>
                            </li>
                            </ol>
                        </Fragment>
            </Grid>
            <Grid item xs={12}>
                <Divider />
            </Grid>
            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }} >
                <DeleteCancel onDelete={onRegenerate} onCancel={onClose} content={'Proceed'} />
            </Grid>


        </Grid>
    )
}

